/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RedshiftRestoreDestination {
  /**
  * AWS region where the Redshift resource will be restored.
  */
  'region': string;
  /**
  * Identifier for the restored provisioned cluster. Must be unique within the AWS account and region.
  */
  'clusterIdentifier'?: string;
  /**
  * Name for the restored serverless namespace. Only used for serverless restores.
  */
  'namespaceName'?: string;
  /**
  * Node type for the restored provisioned cluster. If not provided, the original node type will be used.
  */
  'nodeType'?: string;
  /**
  * Number of nodes for the restored provisioned cluster. If not provided, the original value will be used.
  */
  'numberOfNodes'?: number;
  /**
  * Subnet group name for VPC placement of the restored cluster.
  */
  'subnetGroupName'?: string;
  /**
  * VPC security group IDs for the restored cluster.
  */
  'vpcSecurityGroupIds'?: Array<string>;
  /**
  * Port number for the restored cluster. Defaults to 5439 if not provided.
  */
  'port'?: number;
  /**
  * KMS key ARN for encrypting the restored cluster. If not provided, the original encryption setting will be used.
  */
  'encryptionKey'?: string;
  /**
  * Tags to apply to the restored Redshift resource.
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "clusterIdentifier",
      "baseName": "clusterIdentifier",
      "type": "string",
      "format": ""
    },
    {
      "name": "namespaceName",
      "baseName": "namespaceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "nodeType",
      "baseName": "nodeType",
      "type": "string",
      "format": ""
    },
    {
      "name": "numberOfNodes",
      "baseName": "numberOfNodes",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "subnetGroupName",
      "baseName": "subnetGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpcSecurityGroupIds",
      "baseName": "vpcSecurityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "port",
      "baseName": "port",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

